<template>
  <div>
    <b-sidebar width="600px" id="ship-edit" shadow>
      <div>
        <b-card>
          <b-container>
            <div class="mb-2" align="right">
              <b-button size="sm" type="button" @click="registerEcdis"
                :disabled="!(emailsNState && shipName && imoState && permitState && countryState)" variant="info">
                Save
              </b-button>&nbsp;
            </div>
  
            <b-form size="sm" @submit="registerEcdis" v-if="show">
              <b-form-group size="sm" :label="$t('ships.emails')" label-for="input-1">
                <b-form-input size="sm" id="input-1" v-model="form.email" type="text" :state="emailsNState" placeholder=""
                  required />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.shipName')" label-for="input-2">
                <b-form-input id="input-2" v-model="form.ship_name" type="text" placeholder="" :state="shipName"
                  required />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.imo')" label-for="input-3">
                <b-form-input id="input-3" v-model="form.ship_imo" type="text" :state="imoState"
                  placeholder="IMO*******" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.mmsi')" label-for="input-4">
                <b-form-input id="input-4" v-model="form.ship_mmsi" type="text" :state="imoState" placeholder="" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.callSign')" label-for="input-8">
                <b-form-input id="input-8" v-model="form.ship_callsign" type="text" :state="imoState" placeholder="" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.permit')" label-for="input-9">
                <b-form-input id="input-9" v-model="form.permit_main" type="text" :state="permitState" placeholder=""
                  required />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.country')" label-for="input-14" required>
                <b-form-select id="input-14" v-model="form.country" :options="country" :state="countryState" required />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.length')" label-for="input-18">
                <b-form-input id="input-18" v-model="form.ship_l" type="number" placeholder="(optional)" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.width')" label-for="input-19">
                <b-form-input id="input-19" v-model="form.ship_w" type="number" placeholder="(optional)" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.height')" label-for="input-20">
                <b-form-input id="input-20" v-model="form.ship_h" type="number" placeholder="(optional)" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.draught')" label-for="input-22">
                <b-form-input id="input-22" v-model="form.ship_d" type="number" placeholder="(optional)" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.shipCategory')" label-for="input-5">
                <b-form-select id="input-5" v-model="form.ship_category" :options="categories" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.brand')" label-for="input-6">
                <b-form-select id="input-6" v-model="form.ecdis_brand" :options="brands" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.os')" label-for="input-7">
                <b-form-select id="input-7" v-model="form.ecdis_os" :options="systems" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.permit1')" label-for="input-10">
                <b-form-input id="input-10" v-model="form.permits_backup[0]" type="text" :state="permitState0"
                  placeholder="(optional)" />
              </b-form-group>
              <b-form-group size="sm" :label="$t('ships.permit2')" label-for="input-11">
                <b-form-input id="input-11" v-model="form.permits_backup[1]" type="text" :state="permitState1"
                  placeholder="(optional)" />
              </b-form-group>
            </b-form>
          </b-container>
        </b-card>
        <br>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import { registerECDIS } from "@/helpers/api";
import { updateECDIS } from "@/helpers/api";

export default {
  props: {
    value: Array,
    fields: Array
  },
  data() {
    return {
      is_edit: false,
      edit_item: null,
      form: {
        email: '',
        delivery_email: '',
        ship_appid: 11,
        ship_name: '',
        ship_imo: '',
        ship_mmsi: '',
        ship_callsign: '',
        ship_category: '',

        ship_l: '',
        ship_w: '',
        ship_h: '',
        ship_d: '',

        country: '',

        ecdis_brand: '',
        ecdis_os: '',
        ecdis_type: '',

        permit_main: '',
        permits_backup: ['', ''],
      },
      // Большие массивы удалены из data
      show: true,
    }
  },
  mounted() {
    // Определяем обработчики как свойства экземпляра компонента
    this.populateShipFormHandler = (formData) => {
      if (this._isDestroyed) return;
      console.log(formData)

      this.form.ship_appid = formData.ship_appid || 11,
        this.form.email = formData.user_email || '';
      this.form.ship_name = formData.ship_name || '';
      this.form.ship_imo = formData.ship_imo || '';
      this.form.ship_mmsi = formData.ship_mmsi || '';
      this.form.ship_l = formData.ship_l || '';
      this.form.ship_w = formData.ship_w || '';
      this.form.ship_h = formData.ship_h || '';
      this.form.ship_d = formData.ship_d || '';
      this.form.permit_main = formData.permit_main || '';
      this.form.permits_backup[0] = formData.permit_backup || '';
      this.form.permits_backup[1] = formData.permit_backup2 || '';
      this.form.ecdis_os = formData.ecdis_os || '';
      this.form.ecdis_brand = formData.ecdis_brand || '';
      this.form.country = formData.ship_country || '';
      this.form.ship_callsign = formData.ship_callsign || '';
      this.form.ship_category = formData.ship_category || '';

      this.is_edit = formData.is_edit || false;
      this.edit_item = formData.deviceId || null;
    };

    this.cleanShipFormHandler = () => {
      if (this._isDestroyed) return;
      this.form.email = ''
      this.form.ship_appid = 11
      this.form.ship_name = ''
      this.form.ship_mmsi = ''
      this.form.ship_imo = ''
      this.form.ship_l = '';
      this.form.ship_w = '';
      this.form.ship_h = '';
      this.form.ship_d = '';
      this.form.permit_main = ''
      this.form.ecdis_os = ''
      this.form.ecdis_brand = ''
      this.form.country = ''
      this.form.ship_callsign = ''
      this.form.ship_category = ''
      this.form.permits_backup[0] = ''
      this.form.permits_backup[1] = ''
      this.is_edit = false
      this.edit_item = null
    };

    // Подписываемся на события
    eventBus.$on('populate-ship-form', this.populateShipFormHandler);
    eventBus.$on('clean-ship-form', this.cleanShipFormHandler);
  },
  beforeDestroy() {


    this.$root.$emit('bv::hide::sidebar', 'ship-edit');
    this.show = false;
    this._isDestroyed = true; // Флаг для предотвращения асинхронных операций на уничтоженном компоненте    

    // Отписываемся от событий, используя сохраненные обработчики
    if (this.populateShipFormHandler) {
      eventBus.$off('populate-ship-form', this.populateShipFormHandler);
    }
    if (this.cleanShipFormHandler) {
      eventBus.$off('clean-ship-form', this.cleanShipFormHandler);
    }

    // this.$root.$off('bv::toggle::collapse');

    // Очищаем данные и обработчики для предотвращения утечек памяти
    this.form = null;
    this.edit_item = null;
    this.populateShipFormHandler = null;
    this.cleanShipFormHandler = null;
  },
  computed: {
    // Переносим большие статические массивы из data в computed
    categories() {
      return [{ text: '(optional)', value: '' }, 'BRGE Barge', 'WMS WMS', 'CAR Vehicle Carrier', 'COMB Combination', 'CONT Container', 'DRDG Dredger', 'ICE Icebreaker', 'NOT Not a Vessel', 'NVY Naval vessel', 'PASS Passenger Vessel', 'PILOT Pilot', 'RES Research Vessel', 'RFR Reefer', 'RORO Ro-Ro', 'SLV Salvage Vessel', 'SRV Survey Vessel', 'TUG Tug', 'VTS Vessel Traffic System', 'CRG Dry Cargo/Passenger', 'FSH Fishing', 'BULK Bulk Carriers', 'OFS Offshore', 'OTH Miscellaneous', 'TNK Tankers', 'INLW Inland Watwerways', 'NONM Non-Merchant Ships', 'NONP Non Propelled', 'NSS Non Ship Structures'];
    },
    country() {
      return [{ text: '', value: '' }, 'AL Albania', 'DZ Algeria', 'AO Angola', 'AG Antigua and Barbuda', 'AR Argentina', 'AW Aruba', 'AU Australia', 'AT Austria', 'BS Bahamas', 'BH Bahrain', 'BD Bangladesh', 'BB Barbados', 'BE Belgium', 'B1 Belgium', 'BZ Belize', 'BJ Benin', 'BM Bermuda', 'BO Bolivia', 'BR Brazil', 'B2 Brunei Darussalam', 'BN Brunei Darussalam', 'BG Bulgaria', 'KH Cambodia', 'CM Cameroon', 'CA Canada', 'CV Cape Verde', 'CL Chile', 'C1 China C1', 'C2 China C2', 'CN China CN', 'CO Colombia', 'KM Comoros', 'CD Congo (Dem. Rep. Of)', 'CG Congo(Rep. of)', 'CK Cook Islands', 'CR Costa-Rica', 'CI Côte d’Ivoire', 'HR Croatia', 'CU Cuba', 'CY Cyprus', 'CZ Czech Republic', 'DK Denmark', 'D1 Denmark', 'DJ Djibouti', 'DM Dominica', 'DO Dominican Rep.', 'EC Ecuador', 'EG Egypt', 'SV El Salvador', 'GQ Equatorial Guinea', 'ER Eritrea', 'EE Estonia', 'ET Ethiopia', 'FO Faeroeyene', 'FJ Fiji', 'FI Finland', 'FR France', 'GA Gabon', 'GM Gambia', 'GE Georgia', 'DE Germany', 'GH Ghana', 'GR Greece', 'GD Grenada', 'GT Guatemala', 'G1 Guatemala', 'GN Guinea', 'GW Guinea-Bissau', 'GY Guyana', 'HT Haiti', 'HN Honduras', 'IS Iceland', 'IN India', 'ID Indonesia', 'IR Iran', 'IQ Iraq', 'IE Ireland', 'IL Israel', 'IT Italy', 'JM Jamaica', 'JP Japan', 'JO Jordan', 'KE Kenya', 'KI Kiribati', 'KP Korea (DPR of)', 'KR Korea (Rep. of)', 'KW Kuwait', 'LV Latvia', 'LB Lebanon', 'LR Liberia', 'LY Libyan Arab Jamahiriya', 'LT Lithuania', 'LU Luxembourg', 'MG Madagascar', 'MW Malawi', 'MY Malaysia', 'MV Maldives', 'MT Malta', 'MH Marshall Islands', 'MR Mauritania', 'MU Mauritius', 'MX Mexico', 'FM Micronesia(Federated States of)', 'MC Monaco', 'MN Mongolia', 'ME Montenegro', 'MA Morocco ', 'MZ Mozambique', 'MM Myanmar', 'NA Namibia', 'NR Nauru', 'NL Netherlands', 'NZ New Zealand', 'NI Nicaragua', 'NG Nigeria', 'NU Niue ', 'NO Norway', 'N1 Norway', 'OM Oman', 'PK Pakistan', 'PW Palau', 'PA Panama', 'PG Papua New Guinea', 'PY Paraguay', 'PE Peru', 'PH Philippines', 'PL Poland', 'PT Portugal', 'QA Qatar', 'RO Romania ', 'RU Russian Federation', 'KN Saint Kitts and Nevis', 'LC Saint Lucia', 'VC Saint Vincent and the Grenadines', 'WS Samoa', 'ST Sao Tome and Principe', 'SA Saudi Arabia', 'SN Senegal', 'SC Seychelles', 'SL Sierra Leone', 'SG Singapore', 'SI Slovenia', 'SB Solomon Islands', 'SO Somalia', 'ZA South Africa(Rep. of)', 'ES Spain', 'LK Sri Lanka', 'SD Sudan', 'SR Suriname', 'SE Sweden', 'CH Switzerland', 'SY Syrian Arab Republic', '1U Taiwan', 'TZ Tanzania', 'TH Thailand', 'TG Togo', 'TK Tokelau', 'TO Tonga', 'TT Trinidad&Tobago', 'TN Tunisia', 'TR Turkey', 'TV Tuvalu', 'UA Ukraine', 'AE United Arab Emirates', 'GB United Kingdom', 'NN Unknown', 'UY Uruguay', 'U1 USA', 'U2 USA', 'US USA', 'VU Vanuatu', 'VE Venezuela', 'VN Viet Nam', 'YE Yemen', 'YU Yugoslavia', 'ZZ Zanzibar'];
    },
    brands() {
      return [{ text: '(optional)', value: '' }, 'dKart', 'dKart Navigator', 'dKart Fishing', 'FURUNO', 'GEM Elettronica', 'GMSTECH', 'Highlander', 'Kelvin Hughes', 'Kongsberg Maritime', 'Maris', 'mKart MEGA ECDIS', 'NAUDEQ', 'Navis USA LLC', 'NaviSailor', 'PC Maritime', 'Raytheon Anschütz', 'Seatronx', 'Sodena', 'Sperry Marine', 'TOKIO KEIKI', 'Transas', 'JRC', 'Unknown'];
    },
    systems() {
      return [{ text: '(optional)', value: '' }, 'Windows', 'Linux', 'Android',];
    },
    types() {
      return [{ text: '(optional)', value: '' }, 'Main', 'Backup',];
    },
    // ...existing computed properties...
    emailsNState() {
      if (!this.form || !this.form.email) return false;
      return !this.form.email.includes(" ") && this.form.email.includes("@") && this.form.email.includes(".");
    },
    countryState() {
      if (!this.form) return false;
      return this.form.country !== '';
    },
    shipName() {
      if (!this.form) return false;
      return this.form.ship_name.length > 1;
    },
    permitState() {
      if (!this.form) return false;
      return this.validatePermit(this.form.permit_main);
    },
    permitState0() {
      if (!this.form) return false;
      return this.validatePermit(this.form.permits_backup[0], true);
    },
    permitState1() {
      if (!this.form) return false;
      return this.validatePermit(this.form.permits_backup[1], true);
    },
    imoState() {
      if (!this.form) return false;
      if (this.form.ship_imo.length > 0)
        return this.form.ship_imo.length === 10 && this.form.ship_imo.startsWith("IMO")
      else
        return this.form.ship_mmsi.length === 9 || this.form.ship_callsign.length > 2
    },
    callsignState() {
      if (!this.form) return false;
      return this.form.ship_callsign.length <= 10;
    },
    mmsiState() {
      if (!this.form) return false;
      return this.form.ship_mmsi.length < 20;
    }
  },
  methods: {
    validatePermit(permit, isBackup = false) {
      // Пустые пермиты (для резервных пермитов) считаются валидными
      if (permit.length === 0 && isBackup) {
        return true;
      }

      // Проверка корректной длины пермита
      if (permit.length !== 28) {
        return false;
      }

      // Функция для расчета CRC32
      const crc32 = function (r) {
        for (var a, o = [], c = 0; c < 256; c++) {
          a = c;
          for (var f = 0; f < 8; f++) a = 1 & a ? 3988292384 ^ a >>> 1 : a >>> 1;
          o[c] = a;
        }
        for (var n = -1, t = 0; t < r.length; t++) n = n >>> 8 ^ o[255 & (n ^ r.charCodeAt(t))];
        return (-1 ^ n) >>> 0;
      };

      // Разделение пермита на код и контрольную сумму
      const code = permit.slice(0, 16);
      const crc = permit.slice(16, 24);

      // Расчет контрольной суммы для проверки
      let check = crc32(code).toString(16).toUpperCase();
      check = ('0000000' + check).slice(-8);

      // Сравнение расчетной и фактической контрольных сумм
      return crc === check;
    },
    registerEcdis() {
      if (this._isDestroyed) return;
      let data = {
        userPermit: this.form.permit_main,
        notificationEmails: this.form.email,
        deliveryEmail: this.form.delivery_email,
        applicationTypeId: this.form.ship_appid,
        backupUserPermits: this.form.permits_backup,
        shipInfo: {
          name: this.form.ship_name,
          imo: this.form.ship_imo,
          mmsi: this.form.ship_mmsi,
          callSign: this.form.ship_callsign,
          category: this.form.ship_category,
          ecdisBrand: this.form.ecdis_brand,
          ecdisOs: this.form.ecdis_os,
          flag: this.form.country,
          length: this.form.ship_l,
          width: this.form.ship_w,
          height: this.form.ship_h,
          draught: this.form.ship_d
        },
      }

      if (!this.is_edit)
        registerECDIS(data).then(() => {
          if (!this._isDestroyed) {
            console.log('Ship registered successfully');

            // Закрываем sidebar после успешной регистрации
            this.$root.$emit('bv::toggle::collapse', 'ship-edit');

            // Показываем уведомление о успешной регистрации
            this.$bvToast.toast('Ship has been registered successfully', {
              title: 'Ship Registered',
              variant: 'success',
              solid: true,
              autoHideDelay: 4000,
            });

            // Оповещаем родительский компонент о необходимости обновить данные
            eventBus.$emit('ship-registered');

            // Fallback: пробуем также через $parent если eventBus не сработает
            if (this.$parent && this.$parent.refreshData) {
              this.$parent.refreshData();
            }
          }
        }).catch((error) => {
          console.error('Error registering ship:', error);
          this.$bvToast.toast('Error registering ship', {
            title: 'Registration Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        })
      else {
        data["deviceId"] = this.edit_item
        updateECDIS(data).then(() => {
          if (!this._isDestroyed) {
            console.log('Ship updated successfully');

            // Закрываем sidebar после успешного обновления
            this.$root.$emit('bv::toggle::collapse', 'ship-edit');

            // Показываем уведомление о успешном обновлении
            this.$bvToast.toast('Ship information has been updated successfully', {
              title: 'Ship Updated',
              variant: 'success',
              solid: true,
              autoHideDelay: 4000,
            });

            // Оповещаем родительский компонент о необходимости обновить данные
            eventBus.$emit('ship-updated');

            // Fallback: пробуем также через $parent если eventBus не сработает
            if (this.$parent && this.$parent.refreshData) {
              this.$parent.refreshData();
            }
          }
        }).catch((error) => {
          console.error('Error updating ship:', error);
          this.$bvToast.toast('Error updating ship information', {
            title: 'Update Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        })
      }
    },
  }
}
</script>
